var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgButtonArrowPurple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 9.5,
    stroke: "#773DD3"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.31249 10.3125H12.9306L11.8343 11.4035C11.7119 11.5253 11.7115 11.7231 11.8332 11.8454C11.955 11.9678 12.1529 11.9682 12.2752 11.8465L13.9081 10.2215C13.9082 10.2214 13.9082 10.2213 13.9083 10.2212C14.0304 10.0995 14.0307 9.90095 13.9084 9.7788C13.9083 9.7787 13.9082 9.7786 13.9081 9.7785L12.2752 8.1535C12.1529 8.03178 11.955 8.03221 11.8333 8.15456C11.7115 8.27689 11.712 8.47475 11.8343 8.5965L12.9306 9.6875H6.31249C6.1399 9.6875 5.99999 9.82741 5.99999 10C5.99999 10.1726 6.1399 10.3125 6.31249 10.3125Z",
    fill: "#773DD3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    fill: "#773DD3",
    transform: "translate(14 14) rotate(-180)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgButtonArrowPurple);
export default __webpack_public_path__ + "static/media/button-arrow-purple.e5b72f4f2f68c00783dbbd60921f0af6.svg";
export { ForwardRef as ReactComponent };